import { z } from "zod";

export const IndexRegulationValidationSchema = z.object({
  percentage: z.number().min(0).max(100, { message: "validation:percentageMustBe0To100" }),
});

export type IndexRegulationFormInput = z.infer<typeof IndexRegulationValidationSchema>;
